export default __webpack_public_path__ + "6b75e1abbec819b4d334f48087126dd5.svg";